import { getStringWidth } from '@visx/text'
import { Orientation } from '@visx/axis'

class AxisService {
  isVertical (orientation) {
    return [Orientation.left, Orientation.right].includes(orientation)
  }

  getMaxNumTicks ({ orientation, width, height, ticks, tickFormat, tickLabelProps, tickLabelHeight }) {
    const isVertical = this.isVertical(orientation)
    if ((isVertical && !height) || (!isVertical && !width)) {
      return // cannot calculate if we don't have the appropriate dimension for the axis
    }

    return isVertical
      ? this.getMaxNumTicksVertical(height, tickLabelHeight)
      : this.getMaxNumTicksHorizontal(width, ticks, tickFormat, tickLabelProps)
  }

  getMaxNumTicksVertical (height, tickLabelHeight) {
    return Math.floor(height / tickLabelHeight) - 1 // first & last really only get half the width
  }

  getMaxNumTicksHorizontal (width, ticks, tickFormat, tickLabelProps) {
    const formattedTicks = tickFormat ? ticks.map(tickFormat) : ticks
    const distinctTicks = [...new Set(formattedTicks)]
    const maxTickWidth = this.calculateMaxTickWidth(distinctTicks, tickLabelProps) + 10 // padding
    const maxFit = Math.floor(width / maxTickWidth) - 1 // first & last really only get half the width
    return Math.min(distinctTicks.length, maxFit)
  }

  calculateMaxTickWidth (ticks, tickLabelProps) {
    return ticks?.length
      ? Math.max(...ticks.map((value) => getStringWidth(value, tickLabelProps)))
      : 0
  }
}

export const axisService = new AxisService()
